import { render, staticRenderFns } from "./ObjectFillFit.vue?vue&type=template&id=8b773342&scoped=true"
import script from "./ObjectFillFit.vue?vue&type=script&lang=js"
export * from "./ObjectFillFit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b773342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b773342')) {
      api.createRecord('8b773342', component.options)
    } else {
      api.reload('8b773342', component.options)
    }
    module.hot.accept("./ObjectFillFit.vue?vue&type=template&id=8b773342&scoped=true", function () {
      api.rerender('8b773342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ObjectFillFit.vue"
export default component.exports